/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BoardDto } from './boardDto';
import { GamePlayerEngineDto } from './gamePlayerEngineDto';
import { SimpleHistoryDto } from './simpleHistoryDto';
import { StepDto } from './stepDto';

export interface GameEngineDto { 
    id?: number;
    name?: string;
    description?: string;
    status?: GameEngineDto.StatusEnum;
    winnerCivilizationName?: string;
    rulesUuid?: string;
    boardUuid?: string;
    rulesId?: number;
    rulesName?: string;
    rulesLocalizedNames?: { [key: string]: string; };
    rulesLocalizedDescriptions?: { [key: string]: string; };
    boardStartId?: number;
    creatorUuid?: string;
    creatorName?: string;
    creatorUsername?: string;
    step?: StepDto;
    playersCount?: number;
    players?: Array<GamePlayerEngineDto>;
    simpleHistorySize?: number;
    version?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
    boardId?: number;
    board?: BoardDto;
    simpleHistory?: SimpleHistoryDto;
}
export namespace GameEngineDto {
    export type StatusEnum = 'CREATED' | 'STARTED' | 'INTERRUPTED' | 'FINISHED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        STARTED: 'STARTED' as StatusEnum,
        INTERRUPTED: 'INTERRUPTED' as StatusEnum,
        FINISHED: 'FINISHED' as StatusEnum
    };
}